import { useQueryClient } from "@tanstack/react-query";
import { useDioceseScope } from "@/lib/diocese-scope";

/**
 * Sélecteur des diocèses autorisés. Avec un seul diocèse rattaché, on affiche
 * un libellé statique (pour que le périmètre courant soit toujours visible) ;
 * avec plusieurs, le <select> de bascule ; aucun → rien.
 * Au changement : met à jour le scope (sessionStorage + header) et invalide
 * les requêtes pour refetch sur le nouveau diocèse.
 */
export default function DioceseSelector() {
  const { dioceseId, setDioceseId, dioceses } = useDioceseScope();
  const qc = useQueryClient();
  if (dioceses.length === 0) return null;
  if (dioceses.length === 1) {
    return (
      <span className="flex items-center gap-2 text-sm" data-testid="diocese-actif">
        <span className="text-white/70">Diocèse :</span>
        <span className="text-white">{dioceses[0].nom}</span>
      </span>
    );
  }
  return (
    <label className="flex items-center gap-2 text-sm">
      <span className="text-white/70">Diocèse :</span>
      <select
        value={dioceseId ?? ""}
        onChange={(e) => {
          setDioceseId(e.target.value);
          qc.invalidateQueries();
        }}
        className="bg-white/10 border border-white/20 rounded px-2 py-1 text-white"
        data-testid="select-diocese"
      >
        {dioceses.map((d) => (
          <option key={d.id} value={d.id} className="text-navy">{d.nom}</option>
        ))}
      </select>
    </label>
  );
}
